import { useGetUserSubscription } from '@forwardflow/hooks/customHooks'
import SubscriptionService from '@forwardflow/services/SubscriptionService'
import { usePauseSubscriptionModalStore } from '@forwardflow/store/modal/pauseSubscriptionModal'
import { Button } from '@forwardflow/ui'
import { Modal } from 'antd'

export const PauseSubscriptionModal = () => {
   const { data, mutate } = useGetUserSubscription()
   const { isPauseSubscriptionModalOpen, closePauseSubscriptionModal } =
      usePauseSubscriptionModalStore()

   const toggleSubscriptionStatus = async () => {
      try {
         if (data?.organizationSubscription?.status === 'active') {
            await SubscriptionService.toggleSubscription('paused')
         } else {
            await SubscriptionService.toggleSubscription('active')
         }
      } catch (error) {
         console.error('Error toggling subscription status:', error)
      } finally {
         closePauseSubscriptionModal()
         mutate()
      }
   }
   return (
      <Modal
         className="ff-modal"
         title={
            data?.organizationSubscription?.status === 'active'
               ? 'Pause subscription'
               : 'Resume subscription'
         }
         open={isPauseSubscriptionModalOpen}
         onCancel={closePauseSubscriptionModal}
         footer={null}
      >
         <p className="mt-5 mb-14">
            {data?.organizationSubscription?.status !== 'active'
               ? 'Are you sure you want to resume Forward Flow Subscription?'
               : ' Are you sure you want to pause Forward Flow Subscription? Forward Flow will no longer nurture your leads. You can reactivate this account within 2 months after pausing.'}
         </p>

         <Button
            onClick={toggleSubscriptionStatus}
            className={`h-12 !w-full !rounded px-7  ${
               data?.organizationSubscription?.status === 'active'
                  ? '!bg-danger/20 hover:!bg-danger/50 !border-danger'
                  : '!bg-primary/10'
            }`}
         >
            {data?.organizationSubscription?.status === 'active'
               ? 'Pause'
               : 'Resume'}
            &nbsp; Subscription
         </Button>

         <button
            onClick={closePauseSubscriptionModal}
            className="w-full h-12 mt-2 font-semibold transition-all border rounded border-white/20 hover:bg-white/10"
         >
            Cancel
         </button>
      </Modal>
   )
}
